import { useEffect } from 'react';
import { useSelectedMarketField } from '../../../store/rootStore.ts';
import { useLastTradesStore } from '../state/lastTradesStore.ts';
import { DEFAULT_TICK_USD_BY_SYMBOL, resolveMarketTickSize, useOrderBookStore } from '../state/orderBookStore.ts';
import { useOrderBookTickLevels } from './useOrderBookTickLevels.ts';

/** Keeps order-book decimals/tick-size in sync on market change even when OrdersPanel is hidden. */
export function useOrderBookMarketSync() {
  const { marketKey, tickLevels } = useOrderBookTickLevels();
  const quoteDecimals = useSelectedMarketField('quoteDecimals');
  const assetDecimals = useSelectedMarketField('assetDecimals');
  const assetCurrency = useSelectedMarketField('symbol') ?? '';

  const preferredTickUsd = assetCurrency ? DEFAULT_TICK_USD_BY_SYMBOL[assetCurrency.toUpperCase()] : undefined;

  useEffect(() => {
    if (!marketKey) {
      return;
    }
    const { tickSize, tickSizeByMarket, setTickSize } = useOrderBookStore.getState();
    const next = resolveMarketTickSize(tickSizeByMarket[marketKey], tickLevels, preferredTickUsd);
    if (next && next !== tickSize) {
      setTickSize(next, marketKey);
    }
  }, [marketKey, tickLevels, preferredTickUsd]);

  useEffect(() => {
    if (quoteDecimals != null && assetDecimals != null) {
      useOrderBookStore.getState().setDecimals(quoteDecimals, assetDecimals);
      useLastTradesStore.getState().setDecimals(quoteDecimals, assetDecimals);
    }
  }, [quoteDecimals, assetDecimals]);
}
